import { Controller, Application } from 'stimulus';
import $ from 'jquery';
import 'jquery-validation';
import { enrichReturnUrlByLoginHint } from './../account-service';

class LoginFormController extends Controller {
  static targets = ['backendErrorSummary', 'clientErrorSummary', 'email', 'forgotPasswordLink', 'loadingSpinner', 'password'];

  private validator?: JQueryValidation.Validator;
  private declare readonly backendErrorSummaryTarget: HTMLElement;
  private declare readonly clientErrorSummaryTarget: HTMLElement;
  private declare readonly emailTarget: HTMLInputElement;
  private declare readonly forgotPasswordLinkTarget: HTMLAnchorElement;
  private declare readonly loadingSpinnerTarget: HTMLElement;
  private declare readonly passwordTarget: HTMLInputElement;

  connect(): void {
    this.validator = $(this.element).validate({
      errorLabelContainer: `#${this.clientErrorSummaryTarget.id}`,
      wrapper: 'li',
      rules: {
        ['Email']: 'required',
        ['Password']: 'required'
      },
      messages: {
        ['Email']: { required: 'Please enter your email' },
        ['Password']: { required: 'Please enter your password' }
      },
      // Validate everything on focus out
      onfocusout: (element: HTMLElement) => {
        // Workaround to hide backend error summary target on focus out event if element is valid.
        const hasValid = $(element).valid();
        if (hasValid) {
          this.backendErrorSummaryTarget.style.display = 'none';
        }
      },
      submitHandler: (form) => {
        this.loadingSpinnerTarget.style.display = 'block';
        form.submit();
      },
      // Hide backend validation errors on focus in
      onfocusin: () => {
        this.backendErrorSummaryTarget.style.display = 'none';
      }
    });

    // Dirty hack to avoid iOS autofocusing HALO-16638
    this.removeTabIndex();
  }

  enrichLoginHint(): void {
    enrichReturnUrlByLoginHint(
      this.forgotPasswordLinkTarget,
      this.emailTarget.value);
  }

  private removeTabIndex() {
    this.emailTarget.removeAttribute('tabindex');
    this.passwordTarget.removeAttribute('tabindex');
  }
}

export function registerLoginFormController(application: Application): void {
  application.register('loginForm', LoginFormController);
}
